import { TabModel } from '@anecdotes/design-system/dropdown-menu';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import {
  AppRoutes,
  AppTrustCenterPageRouteSegments,
} from '@anecdotes/configuration-data-access';
import { TrustCenterTabs } from '../../constants';
import { TrustCenterEventService, TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { Observable } from 'rxjs';
import { SupportRequestService } from '@anecdotes/support';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface Tab extends Pick<TabModel, 'tabId' | 'routerLink' | 'translationKey' | 'notificationDot' | 'count' | 'hideCounterOnZero'> {
  featureFlag?: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  tabs: Tab[];

  hasTrustCenterUrl$: Observable<boolean>;

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private supportRequestService: SupportRequestService,
    private trustCenterEventService: TrustCenterEventService,
    private translate: TranslateService,
    private destroyRef: DestroyRef,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.hasTrustCenterUrl$ = this.trustCenterFacadeService.hasTrustCenterUrl();
    this.trustCenterFacadeService.getOpenUserRequests().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (requests) => {
        this.tabs = [
          {
            tabId: TrustCenterTabs.ActivityDashboard,
            routerLink: `/${AppRoutes.TrustCenter}/${AppTrustCenterPageRouteSegments.ActivityDashboard}`,
            translationKey: this.buildTranslationKey('activityDashboard.tab'),
          },
          {
            tabId: TrustCenterTabs.Preview,
            routerLink: `/${AppRoutes.TrustCenter}/${AppTrustCenterPageRouteSegments.Preview}`,
            translationKey: this.buildTranslationKey('preview.tab'),
            featureFlag: '@trust-center-preview-page',
          },
          {
            tabId: TrustCenterTabs.Access,
            routerLink: `/${AppRoutes.TrustCenter}/${AppTrustCenterPageRouteSegments.Access}`,
            translationKey: this.buildTranslationKey('access.tab'),
            notificationDot: requests.length > 0,
            count: requests.length,
            hideCounterOnZero: true,
          },
          {
            tabId: TrustCenterTabs.Settings,
            routerLink: `/${AppRoutes.TrustCenter}/${AppTrustCenterPageRouteSegments.Settings}`,
            translationKey: this.buildTranslationKey('settings.tab'),
            featureFlag: '@trust-center-settings-page',
          },
        ];

        this.cd.detectChanges();
      },
    );
  }

  buildTranslationKey(relativeKey: string): string {
    return `trustCenter.${relativeKey}`;
  }

  openTrustGuidance(): void {
    this.trustCenterFacadeService.openTrustGuidance();
  }

  contactUs(): void {
    this.trustCenterEventService.trackContactUsClick();

    this.supportRequestService.openTicketAsync({
      subject: this.translate.instant(this.buildTranslationKey('emptyState.ticket.subject')),
      description: '',
    });
  }
}
